import gsap from 'gsap';
import {useGSAP} from "@gsap/react";
import {useRef} from "react";
import useBgColorStore from "../../stores/bgColorStore";

const BGColorChangeWrapper = ({children, colorClass}) => {

    const sectionRef = useRef()
    const { setColorClass } = useBgColorStore();

    useGSAP(()=> {


        gsap.fromTo(sectionRef.current, {opacity: 1}, {opacity: 1, scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top center',
                end: 'bottom center',
                // markers: true,
                onEnter: () => {
                    setColorClass(colorClass)
                },
                onEnterBack: () => {
                    setColorClass(colorClass)
                },
        }})
    })

    return (
        <div ref={sectionRef}>
            {children}
        </div>
    );
};

export default BGColorChangeWrapper;